/* tslint:disable:max-line-length */
import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const fr: DeepPartial<Messages> = {
  custom: {
    clearSearchInput: 'Effacer',
    facetsHeader: 'Filtres'
  },
  close: { buttonText: '' },
  facets: {
    defaultRange: { fromHTML: 'plus de {min}' },
    titles: {
      price_facet: 'Prix',
      sizes_facet: 'Taille',
      color_facet: 'Couleur'
    },
    toggle: {
      default: {
        openHTML: 'Filtrer {numFound} résultats',
        closeHTML: 'Afficher {numFound} résultats'
      }
    }
  },
  history: {
    disable: 'on',
    enable: 'off'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['']
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__mgoccessage-apologies">Nous n'avons pas trouvé de résultats pour </span>
         <span class="ebx-no-results__message-query">{query}'</span><span class="ebx-no-results__message-try-again">
        Voici les produits les plus</span>`
  },
  nextQueries: {
    titleHTML: 'Vous pourriez être intéressé',
    nextQuery: {
      titleHTML: 'D\'autres utilisateurs ont recherché <span class="ebx-next-query__title-query">{query}</span>'
    }
  },
  partialResult: {
    messageHTML: `<span class="ebx-partials__message-apologies">Nous n'avons pas pu trouver des résultats pour </span><span class="ebx-partials__message-query">'{query}'</span><span class="ebx-partials__message-try-again"> Les produits suivants peuvent vous intéresser</span>`,
    titleHTML: '<span class="ebx-partial-result__title-num-found">{numFound}</span> résultats pour <span class="ebx-partial-result__title-term">{term}</span>'

  },
  sort: {
    titleHTML: 'Ordonner par {selectedItem}',
    sortTitles: {
      default: 'Importance',
      priceAsc: 'Prix ascendant',
      priceDesc: 'Prix descendant',
      alphabeat: 'Alphabétiquement'
    }
  }
};
